import moment from 'moment';
import each from 'lodash/each';
import { parse } from 'upath';

export function calc4k(px) {
    const width4k = 2160;
    return `${(px / width4k) * 100}vw`;
}

export function getParameterByName(name, url = false) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function noCacheReq(url, body = {}) {
    return new Promise(resolve => {
        fetch(`${url}?t=${Date.now()}`, {
            method: 'POST',
            headers: new Headers({ 'content-type': 'application/json' }),
            body: JSON.stringify(body)
        }).then(res => {
            res.json().then(json => {
                resolve(json);
            });
        }).catch( err => {
            console.error(err);
        });
    });
}

export function formatTime(date, period) {
    return moment(new Date(date)).format(period ? 'a' : 'hh:mm');
}

export function mysqlDatetime(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

export function decodeHTMLText(str) {
    const parse = new DOMParser();
    return parse.parseFromString(str, 'text/html').body.textContent;
}

export function getSlugFromPath(path) {
    switch( path ) {
        case '/promotions':
            return 'south-lobby-exhibitions';
        case '/events':
            return 'south-court-events';
        case '/membership':
            return 'admissions-1-membership';
        case '/tickets':
            return 'admissions-2-tickets';
        case '/elevator':
        case '/elevator-1':
        case '/elevator-2':
        case '/elevator-3':
            return 'elevator-signs';
        case '/exhibitions':
            return 'north-lobby-exhibitions';
    }
}
